import ApiBase from './base/ApiBase'
import { NameIdSlim } from '../models/custom-models';

export default class SystemUserClient extends ApiBase {
    private controllerName: string = 'SystemUser';

    async GetAll(signal?: AbortSignal): Promise<NameIdSlim[]> {
        return this.GetAsync(`${this.controllerName}`, signal);
    }

    async SearchSystemUser(context: SearchSystemUserContext, signal?: AbortSignal): Promise<SearchSystemUserItem[]> {
        return this.PostAsync(`${this.controllerName}/Search`, context, signal);
    }
}

export interface SearchSystemUserContext {
    FirstName?: string;
    LastName?: string;
    Email?: string;
    OrganizationName?: string;
}

export interface SearchSystemUserItem {
    UserDisplayName: string;
    OrganizationName: string;
    UserId: string;
    OrganizationId: string;
    Email: string;
}

export enum SystemUserErrors {
    Create = 'Error creating System User',
    Delete = 'Error deleting System User',
    GetAll = 'Error loading System Users',
    GetSingle = 'Error loading System User',
    Update = 'Error saving System User',
}
